var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropperBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490.029 490.029",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M483.792,454.658l-34.7-34.7c24.7-37.2,20.7-87.7-12.2-120.6l-164.2-164.2l23.5-23.4c7.7-7.4,9-19.9,0-29.2l-61.5-61.5 c-8.3-8.3-20.8-8.3-29.2,0l-44.9,44.9l-46.8-46c-29.9-27.8-66.7-25.3-93.8,0.1c-25.9,26.3-27.4,65.5,0,93.8l46.3,46.3l-45.3,45.3 c-9.8,9.8-7.7,21.5,0,29.2l60.5,60.5c7,7.5,21.6,9,29.2,1l25.1-24.9l164.6,164.6c30.8,29.7,79.6,38.5,119.3,12.9l35,35 c8.3,8.3,20.8,8.3,29.2,0C492.091,475.558,492.091,462.958,483.792,454.658z M48.191,85.858c-10.2-10.3-10.2-26.9,0-37.1 c10.4-10.4,27.4-10.2,37.5,0.5l41.6,42.7l-36.5,36.5L48.191,85.858z M95.992,252.458l-32.3-32.3l156.4-156.4l32.3,32.3 L95.992,252.458z M406.691,407.758c-27.7,24.1-53.1,20.3-77.2,0l-163.6-163.6l78.2-78.2l162.6,163.6 C428.591,351.458,428.591,385.858,406.691,407.758z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropperBlack);
export default __webpack_public_path__ + "static/media/dropper_black.84998920415c961a31e23d8b78f724ac.svg";
export { ForwardRef as ReactComponent };